import createWorkScheduleReducer from '../../js/administration/workSchedule/workScheduleReducer'
import {combineReducers} from 'redux'
import createLoggedInUserReducer from '../../js/loggedInUser/reducer'
import createActiveLicenseInfoReducer from '../../js/activeLicenseInfo/reducer'
import createSupportReducer from '../../js/support/supportForm/reducer'
import createPasswordReducer from '../../js/administration/passwordSettings/reducer'
import createMailReducer from '../../js/administration/mailSettings/reducer'
import createWelcomeReducer from '../../js/support/welcomeScreen/reducer'
import toasts from '../../js/toasts/reducer'
import createEntitiesReducer from '../../js/entities/reducer'
import createICalReducer from './icalendar/iCalReducer'
import createAddonsReducer from './addons/reducer'
import createLockoutPolicyReducer from '../../js/administration/lockoutPolicy/reducer'
import createLowBalanceSettingsReducer from '../../js/administration/lowBalanceSettings/commonReducer'
import createFeaturesReducer from '../../js/features/reducer'

export default (initAppData) => {
    return combineReducers({
        loggedInUser: createLoggedInUserReducer(initAppData),
        entities: createEntitiesReducer(initAppData),
        workSchedule: createWorkScheduleReducer(initAppData),
        activeLicenseInfo: createActiveLicenseInfoReducer(initAppData),
        support: createSupportReducer(initAppData),
        addons: createAddonsReducer(initAppData),
        lockoutPolicy: createLockoutPolicyReducer(initAppData),
        lowBalanceSettings: createLowBalanceSettingsReducer(initAppData),
        features: createFeaturesReducer(initAppData),
        passwordSettings: createPasswordReducer(initAppData),
        mailSettings: createMailReducer(initAppData),
        welcome: createWelcomeReducer(initAppData),
        iCalendar: createICalReducer(initAppData),
        toasts,
    })
}



// WEBPACK FOOTER //
// ./web/actiplans/js/reducer.js